"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigestAlgorithm = void 0;
var DigestAlgorithm;
(function (DigestAlgorithm) {
    DigestAlgorithm[DigestAlgorithm["SHA256"] = 0] = "SHA256";
    DigestAlgorithm[DigestAlgorithm["SHA512"] = 1] = "SHA512";
})(DigestAlgorithm = exports.DigestAlgorithm || (exports.DigestAlgorithm = {}));
